<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  beforeDestroy() {
    if (this.$store.hasModule("MinistryRelation"))
      this.$store.unregisterModule("MinistryRelation");
  },
};
</script>
